import * as React from 'react';
import { useContext, useMemo } from 'react';
import { LocaleReceiverProps } from './iLocale';
import LocaleContext from './locale-context';
import defaultLocaleData from './zh_CN';

// context 类型定义
interface LocaleContextType {
    [key: string]: any;
    locale?: string;
    exist?: boolean;
}

// children 明确类型
type LocaleReceiverChildren = (
    locale: Record<string, any>,
    localeCode: string,
    context: LocaleContextType
) => React.ReactNode;

const LocaleReceiver: React.FC<LocaleReceiverProps & { children: LocaleReceiverChildren }> = ({
    componentName = 'global',
    defaultLocale,
    children,
}) => {
    const uLocale = useContext(LocaleContext) as LocaleContextType;

    // 计算 locale
    const locale = useMemo(() => {
        const baseLocale = defaultLocale || defaultLocaleData[componentName || 'global'];
        const localeFromContext =
            componentName && uLocale && typeof uLocale === 'object'
                ? uLocale[componentName]
                : {};
        return {
            ...(typeof baseLocale === 'function' ? baseLocale() : baseLocale),
            ...(localeFromContext || {}),
        };
    }, [componentName, defaultLocale, uLocale]);

    // 计算 localeCode
    const localeCode = useMemo(() => {
        const code = uLocale && uLocale.locale;
        if (uLocale && uLocale.exist && !code) {
            return defaultLocaleData.locale;
        }
        return code || '';
    }, [uLocale]);

    return <>{children(locale, localeCode as string, uLocale)}</>;
};

export default LocaleReceiver;